import axios from 'axios';
import { config } from '../config';
import { authService } from './auth';

const api = axios.create({
  baseURL: config.api.baseUrl
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use(async (config) => {
  const token = await authService.getIdToken();
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

export const userApi = {
  // Listar todos os usuários
  listUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  // Buscar usuário específico
  getUser: async (username) => {
    const response = await api.get(`/users/${username}`);
    return response.data;
  },

  // Criar novo usuário
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Deletar usuário
  deleteUser: async (username) => {
    const response = await api.delete(`/users/${username}`);
    return response.data;
  },

  // Atualizar role do usuário
  updateUserRole: async (username, role) => {
    const response = await api.put(`/users/${username}/role`, { role });
    return response.data;
  }
};